export default __webpack_public_path__ + "static/media/faith_logo_text2.38b2d6c9.svg";